<template>
  <div>

    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Team" type="team" />

    <!-- Start team Area  -->
    <TeamNotinList/>

  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)
const PageName= "Equipo"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
       const breadcrumbs= [
          {
            text: "Home",
            to: "/",
            disabled: false,
          },
          {
            text: "Team",
            to: "",
            disabled: true,
          },
        ]
</script>
